import { RoutingConfig } from 'src/app/utils/routing-config';
import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
@Component({
  selector: 'app-pre-prog',
  templateUrl: './pre-prog.component.html',
  styleUrls: ['./pre-prog.component.scss'],
})
export class PreProgComponent implements OnInit {
  constructor(
    private router: Router,
    private routingConfig: RoutingConfig
  ) {}

  async ngOnInit() {
  }
  async return() {
    this.router.navigateByUrl(await this.routingConfig.getBackUrl());  
  }
  async next() {
    this.router.navigateByUrl(await this.routingConfig.getNextUrl());
  }
}
